<template>
  <div class="current-time-parts">
    <svg
      class="current-time-parts__bg current-time-parts__bg--left"
      width="69"
      height="50"
      viewBox="0 0 69 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.25"
        d="M51.0687 5.9102L0.5 50H68.5V0H66.8408C61.0421 0 55.4395 2.09945 51.0687 5.9102Z"
        fill="url(#paint0_linear_223_2101)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_223_2101"
          x1="420.36"
          y1="8.63042e-07"
          x2="420.36"
          y2="50"
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset="1" stop-opacity="0" />
        </linearGradient>
      </defs>
    </svg>
    <svg
      class="current-time-parts__bg current-time-parts__bg--right"
      width="69"
      height="50"
      viewBox="0 0 69 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.25"
        d="M17.9313 5.9102L68.5 50H0.5V0H2.15918C7.95791 0 13.5605 2.09945 17.9313 5.9102Z"
        fill="url(#paint0_linear_223_2103)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_223_2103"
          x1="-351.36"
          y1="8.63042e-07"
          x2="-351.36"
          y2="50"
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset="1" stop-opacity="0" />
        </linearGradient>
      </defs>
    </svg>
    <div class="current-time-parts__bg current-time-parts__bg--center" />

    <span class="current-time-parts__time" v-text="currentTime" />
    <div class="current-time-parts__barcode">
      <img class="current-time-parts__barcode-image" ref="barcodeRef" alt="" src="" />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted, onUnmounted, watch, nextTick } from '@vue/composition-api'
import JsBarcode from 'jsbarcode'
import dayjs from 'dayjs'
import useDisplayDependingOnLang from '@/components/hook/useDisplayDependingOnLang'

/**
 * マイページ: 会員証 現在時刻表示パーツ
 */
export default defineComponent({
  name: 'CurrentTimeParts',
  props: {
    hashedUserId: {
      type: String,
      default: '',
    },
  },
  setup(props) {
    const { getDisplayDate } = useDisplayDependingOnLang()
    const barcodeRef = ref(null)

    /**
     * 現在時刻を取得
     * dayjs使用 YYYY/MM/DD hh:mm:ss 形式
     * @returns 現在時刻
     */
    const getCurrentTime = () =>
      getDisplayDate(dayjs().valueOf(), 'YYYY/MM/DD HH:mm:ss', 'MMM DD, YYYY HH:mm:ss')
    const currentTime = ref<string>(getCurrentTime())

    let currentTimeTimer: number

    onMounted(() => {
      currentTime.value = getCurrentTime()

      currentTimeTimer = window.setInterval(() => {
        currentTime.value = getCurrentTime()
      }, 1000)
    })

    watch(
      () => props.hashedUserId,
      () => {
        nextTick(() => {
          if (barcodeRef.value && props.hashedUserId) {
            JsBarcode(barcodeRef.value, props.hashedUserId, {
              format: 'CODE128',
              lineColor: '#000000',
              width: 2,
              height: 50,
              fontSize: 15,
              textMargin: 2,
              displayValue: true,
            })
          }
        })
      },
      { immediate: true },
    )

    onUnmounted(() => {
      clearInterval(currentTimeTimer)
    })

    return {
      currentTime,
      barcodeRef,
    }
  },
})
</script>

<style lang="scss" scoped>
.current-time-parts {
  position: relative;
  padding-top: 10px;
  width: 100%;
  text-align: center;
  color: $white;

  &__bg {
    position: absolute;
    z-index: -1;
    top: 0;
    height: 50px;
    overflow: visible;

    &--left {
      width: 70px;
      right: calc(100% + 4px);
      transform: translate(34px, 0);
    }

    &--right {
      width: 70px;
      left: calc(100% + 4px);
      transform: translate(-34px, 0);
    }

    &--center {
      left: 29px;
      width: calc(100% - 58px);
      background: linear-gradient(180deg, #000 0%, rgba(0, 0, 0, 0) 100%);
      opacity: 0.25;
    }
  }

  &__time {
    font-family: $fontTelemetrySpeedGear;
    font-size: min(#{convertPXtoVW(18)}, 18px);
    font-style: normal;
    font-weight: 500;
    line-height: 1.11;
    letter-spacing: 0.04em;
  }

  &__barcode {
    margin-top: 8px;

    &-image {
      border-radius: 8px;
      max-width: 350px;
      width: 100%;
    }
  }
}
</style>
